var _ = require('underscore');
var TorsoBehavior = require('backbone-torso/modules/Behavior');
var expandableSectionTemplate = require('./expandableSectionTemplate.hbs');

/**
 * This behavior adds the ability to expand a section with content.
 *
 * @class ExpandableSectionBehavior
 * @constructor
 */
module.exports = TorsoBehavior.extend({

  _defaultHeaderMessageKey: 'expandableSection.header.default',
  _defaultInitiallyExpanded: true,
  _defaultInitiallyShowSection: true,

  events: {
    'click [data-expand-section]': '_toggleShowDetails'
  },

  /**
   * @method initialize
   * @param attributes {Object}
   * @param options {Object}
   *   @param [options.headerMessageKey='expandableSection.header.default'] {String} the message key to use for the header text.
   *   @param [options.initiallyExpanded=true] {Boolean} whether to start expanded (true) or collapsed (false).
   *   @param [options.initiallyShowSection=true] {Boolean} whether to show the entire section (including expandable header).
   */
  initialize: function(attributes, options) {
    this.set('headerMessageKey', options.headerMessageKey || this._defaultHeaderMessageKey);

    var showSection = options.initiallyShowSection;
    if (_.isUndefined(showSection)) {
      showSection = this._defaultInitiallyShowSection;
    }
    this.set('showSection', showSection);

    var showDetails = options.initiallyExpanded;
    if (_.isUndefined(showDetails)) {
      showDetails = this._defaultInitiallyExpanded;
    }
    this.set('showDetails', showDetails);

    this.on('change:showDetails change:showSection', this.view.render, this.view);
  },

  /**
   * Set the details view to show when the widget is expanded.
   * @method setDetailsView
   * @param detailsView {TorsoView} the view to display in the details of the section.
   */
  setDetailsView: function(detailsView) {
    this._detailsView = detailsView;
  },

  /**
   * @param showSection {Boolean} If true then this entire view should be shown.  If false, then nothing should be shown.
   */
  setShowSection: function(showSection) {
    this.set('showSection', showSection);
  },

  mixin: {
    /**
     * Override the template if not set by the view.
     */
    template: expandableSectionTemplate
  },

  /**
   * @method attachTrackedViews
   * @override
   */
  attachTrackedViews: function() {
    if (this._detailsView) {
      this.view.attachView('details', this._detailsView);
    }
  },

  /**
   * Flip whether the details are shown or not.
   * @method _toggleShowDetails
   * @private
   */
  _toggleShowDetails: function(event) {
    event.preventDefault();
    var showDetails = this.get('showDetails');
    this.set('showDetails', !showDetails);
  }
});
